// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.styles_validacao_senha__aA9dE {
    font-size: .9rem;
    list-style-type: none;
    margin: 1rem;
  }
  
  .styles_validacao_true__4Q99C {
    align-items: center;
    color: green;
    display: flex;
  }
  
  .styles_validacao_false__X9t0Z {
    color: red;
  }`, "",{"version":3,"sources":["webpack://./src/components/ValidadorSenha/styles.module.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,UAAU;EACZ","sourcesContent":["\n.validacao_senha {\n    font-size: .9rem;\n    list-style-type: none;\n    margin: 1rem;\n  }\n  \n  .validacao_true {\n    align-items: center;\n    color: green;\n    display: flex;\n  }\n  \n  .validacao_false {\n    color: red;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"validacao_senha": `styles_validacao_senha__aA9dE`,
	"validacao_true": `styles_validacao_true__4Q99C`,
	"validacao_false": `styles_validacao_false__X9t0Z`
};
export default ___CSS_LOADER_EXPORT___;
